<template src="./SummaryText.html"></template>

<script>
export default {
  data() {
    return {
      
    };

  },
      props: {
      nombreResumen: {
        type: String,
        default: "Terapia"
      },
      textoResumen: {
        type: String,
        default: null
      },
      stateGraphic: {
        type: Boolean,
        default: true
      }
    },
};
</script>

<style src="./SummaryText.scss" lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/Terapias/SummaryText/SummaryText.vue